var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "Form",
        {
          ref: "formValidate",
          attrs: {
            model: _vm.formItem,
            rules: _vm.ruleValidate,
            "label-width": 80
          }
        },
        [
          _c("div", { staticClass: "pagesContent" }, [
            _c(
              "div",
              { staticClass: "leftContent" },
              [
                _c("div", { staticClass: "title" }, [
                  _c("h3", [
                    _vm._v("\n            孕妇信息\n            "),
                    _c("span", { staticClass: "desc" }, [
                      _vm._v("不填预产期将无法在用户档案查看该客户")
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "Row",
                  [
                    _c(
                      "Col",
                      { attrs: { span: "12" } },
                      [
                        _c(
                          "FormItem",
                          {
                            attrs: {
                              label: "预产期",
                              prop: "member.child_birth"
                            }
                          },
                          [
                            _c("DatePicker", {
                              staticStyle: { display: "block" },
                              attrs: { type: "date", placeholder: "请选择" },
                              model: {
                                value: _vm.formItem.member.child_birth,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.formItem.member,
                                    "child_birth",
                                    $$v
                                  )
                                },
                                expression: "formItem.member.child_birth"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "Col",
                      { attrs: { span: "12" } },
                      [
                        _c(
                          "FormItem",
                          {
                            attrs: {
                              label: "分娩医院",
                              prop: "member.hospital"
                            }
                          },
                          [
                            _c(
                              "Select",
                              {
                                attrs: {
                                  filterable: "",
                                  remote: "",
                                  clearable: "",
                                  "remote-method": _vm.remoteMethod1,
                                  loading: _vm.remoteLoading
                                },
                                on: { "on-query-change": _vm.remoteMethod },
                                model: {
                                  value: _vm.formItem.member.hospital,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formItem.member,
                                      "hospital",
                                      $$v
                                    )
                                  },
                                  expression: "formItem.member.hospital"
                                }
                              },
                              _vm._l(_vm.hospitalList, function(option, index) {
                                return _c(
                                  "Option",
                                  {
                                    key: index,
                                    attrs: {
                                      value: option.label,
                                      label: option.label
                                    }
                                  },
                                  [
                                    _c("span", [_vm._v(_vm._s(option.label))]),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          float: "right",
                                          color: "#ccc"
                                        }
                                      },
                                      [_vm._v(_vm._s(option.value))]
                                    )
                                  ]
                                )
                              }),
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "title" }, [
                  _c("h3", [_vm._v("基本信息")])
                ]),
                _vm._v(" "),
                _c(
                  "Row",
                  [
                    _c(
                      "Col",
                      { attrs: { span: "12" } },
                      [
                        _c(
                          "FormItem",
                          { attrs: { label: "姓名", prop: "member.name" } },
                          [
                            _c("Input", {
                              attrs: { placeholder: "请输入" },
                              model: {
                                value: _vm.formItem.member.name,
                                callback: function($$v) {
                                  _vm.$set(_vm.formItem.member, "name", $$v)
                                },
                                expression: "formItem.member.name"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "Col",
                      { attrs: { span: "12" } },
                      [
                        _c(
                          "FormItem",
                          {
                            attrs: { label: "身份证", prop: "member.id_card" }
                          },
                          [
                            _c("Input", {
                              attrs: { maxlength: 18, placeholder: "请输入" },
                              on: {
                                "on-blur": function($event) {
                                  return _vm.idCardBlur(
                                    _vm.formItem.member.id_card
                                  )
                                }
                              },
                              model: {
                                value: _vm.formItem.member.id_card,
                                callback: function($$v) {
                                  _vm.$set(_vm.formItem.member, "id_card", $$v)
                                },
                                expression: "formItem.member.id_card"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "Row",
                  [
                    _c(
                      "Col",
                      { attrs: { span: "12" } },
                      [
                        _c(
                          "FormItem",
                          {
                            attrs: {
                              label: "出生日期",
                              prop: "member.birthday"
                            }
                          },
                          [
                            _c("DatePicker", {
                              staticStyle: { display: "block" },
                              attrs: { type: "date", placeholder: "请选择" },
                              model: {
                                value: _vm.formItem.member.birthday,
                                callback: function($$v) {
                                  _vm.$set(_vm.formItem.member, "birthday", $$v)
                                },
                                expression: "formItem.member.birthday"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "Col",
                      { attrs: { span: "12" } },
                      [
                        _c(
                          "FormItem",
                          { attrs: { label: "手机号", prop: "member.phone" } },
                          [
                            _c("Input", {
                              attrs: { maxlength: 11, placeholder: "请输入" },
                              on: { "on-change": _vm.changPhone },
                              model: {
                                value: _vm.formItem.member.phone,
                                callback: function($$v) {
                                  _vm.$set(_vm.formItem.member, "phone", $$v)
                                },
                                expression: "formItem.member.phone"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "Row",
                  [
                    _c(
                      "Col",
                      { attrs: { span: "12" } },
                      [
                        _c(
                          "FormItem",
                          { attrs: { label: "性别", prop: "member.sex" } },
                          [
                            _c(
                              "RadioGroup",
                              {
                                model: {
                                  value: _vm.formItem.member.sex,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formItem.member, "sex", $$v)
                                  },
                                  expression: "formItem.member.sex"
                                }
                              },
                              [
                                _c("Radio", { attrs: { label: "1" } }, [
                                  _vm._v("男")
                                ]),
                                _vm._v(" "),
                                _c("Radio", { attrs: { label: "2" } }, [
                                  _vm._v("女")
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "Col",
                      { attrs: { span: "12" } },
                      [
                        _c(
                          "FormItem",
                          {
                            attrs: {
                              label: "咨询日期",
                              prop: "member.consult_time"
                            }
                          },
                          [
                            _c("DatePicker", {
                              staticStyle: { display: "block" },
                              attrs: { type: "date", placeholder: "请选择" },
                              model: {
                                value: _vm.formItem.member.consult_time,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.formItem.member,
                                    "consult_time",
                                    $$v
                                  )
                                },
                                expression: "formItem.member.consult_time"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "Row",
                  [
                    _c(
                      "Col",
                      { attrs: { span: "24" } },
                      [
                        _c(
                          "Col",
                          { attrs: { span: "7" } },
                          [
                            _c(
                              "FormItem",
                              {
                                attrs: {
                                  label: "所在区域",
                                  prop: "member.province_id"
                                }
                              },
                              [
                                _c(
                                  "Select",
                                  {
                                    attrs: { placeholder: "请选择" },
                                    on: { "on-change": _vm.changeProvince },
                                    model: {
                                      value: _vm.formItem.member.province_id,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formItem.member,
                                          "province_id",
                                          $$v
                                        )
                                      },
                                      expression: "formItem.member.province_id"
                                    }
                                  },
                                  _vm._l(_vm.province, function(item) {
                                    return _c(
                                      "Option",
                                      {
                                        key: item.id,
                                        attrs: { value: item.id }
                                      },
                                      [_vm._v(_vm._s(item.name))]
                                    )
                                  }),
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "Col",
                          { attrs: { span: "4" } },
                          [
                            _c(
                              "FormItem",
                              {
                                attrs: {
                                  "label-width": 0,
                                  prop: "member.city_id"
                                }
                              },
                              [
                                _c(
                                  "Select",
                                  {
                                    attrs: { placeholder: "请选择" },
                                    on: { "on-change": _vm.changeCity },
                                    model: {
                                      value: _vm.formItem.member.city_id,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formItem.member,
                                          "city_id",
                                          $$v
                                        )
                                      },
                                      expression: "formItem.member.city_id"
                                    }
                                  },
                                  _vm._l(_vm.city, function(item) {
                                    return _c(
                                      "Option",
                                      {
                                        key: item.id,
                                        attrs: { value: item.id }
                                      },
                                      [_vm._v(_vm._s(item.name))]
                                    )
                                  }),
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "Col",
                          { attrs: { span: "4" } },
                          [
                            _c(
                              "FormItem",
                              {
                                attrs: {
                                  "label-width": 0,
                                  prop: "member.area_id"
                                }
                              },
                              [
                                _c(
                                  "Select",
                                  {
                                    attrs: { placeholder: "请选择" },
                                    model: {
                                      value: _vm.formItem.member.area_id,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formItem.member,
                                          "area_id",
                                          $$v
                                        )
                                      },
                                      expression: "formItem.member.area_id"
                                    }
                                  },
                                  _vm._l(_vm.area, function(item) {
                                    return _c(
                                      "Option",
                                      {
                                        key: item.id,
                                        attrs: { value: item.id }
                                      },
                                      [_vm._v(_vm._s(item.name))]
                                    )
                                  }),
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "Col",
                          { attrs: { span: "9" } },
                          [
                            _c(
                              "FormItem",
                              {
                                attrs: {
                                  "label-width": 0,
                                  prop: "member.address"
                                }
                              },
                              [
                                _c("Input", {
                                  attrs: { placeholder: "请输入详细地址" },
                                  model: {
                                    value: _vm.formItem.member.address,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.formItem.member,
                                        "address",
                                        $$v
                                      )
                                    },
                                    expression: "formItem.member.address"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "Row",
                  [
                    _c(
                      "Col",
                      { attrs: { span: "24" } },
                      [
                        _c(
                          "FormItem",
                          { attrs: { label: "备注", prop: "member.remark" } },
                          [
                            _c("Input", {
                              attrs: {
                                type: "textarea",
                                maxlength: 200,
                                autosize: { minRows: 2, maxRows: 5 },
                                placeholder: "请输入200字以内"
                              },
                              model: {
                                value: _vm.formItem.member.remark,
                                callback: function($$v) {
                                  _vm.$set(_vm.formItem.member, "remark", $$v)
                                },
                                expression: "formItem.member.remark"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "title" }, [
                  _c("h3", [_vm._v("其他信息")])
                ]),
                _vm._v(" "),
                _c(
                  "Row",
                  [
                    _c(
                      "Col",
                      { attrs: { span: "12" } },
                      [
                        _c(
                          "FormItem",
                          { attrs: { label: "民族", prop: "member.nation" } },
                          [
                            _c("Input", {
                              attrs: { placeholder: "请输入" },
                              model: {
                                value: _vm.formItem.member.nation,
                                callback: function($$v) {
                                  _vm.$set(_vm.formItem.member, "nation", $$v)
                                },
                                expression: "formItem.member.nation"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "Col",
                      { attrs: { span: "12" } },
                      [
                        _c(
                          "FormItem",
                          {
                            attrs: { label: "籍贯", prop: "member.birth_place" }
                          },
                          [
                            _c("Input", {
                              attrs: { placeholder: "请输入" },
                              model: {
                                value: _vm.formItem.member.birth_place,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.formItem.member,
                                    "birth_place",
                                    $$v
                                  )
                                },
                                expression: "formItem.member.birth_place"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "Row",
                  [
                    _c(
                      "Col",
                      { attrs: { span: "12" } },
                      [
                        _c(
                          "FormItem",
                          {
                            attrs: { label: "学历", prop: "member.education" }
                          },
                          [
                            _c("Input", {
                              attrs: { placeholder: "请输入" },
                              model: {
                                value: _vm.formItem.member.education,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.formItem.member,
                                    "education",
                                    $$v
                                  )
                                },
                                expression: "formItem.member.education"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "Col",
                      { attrs: { span: "12" } },
                      [
                        _c(
                          "FormItem",
                          { attrs: { label: "身高", prop: "member.height" } },
                          [
                            _c(
                              "Input",
                              {
                                attrs: {
                                  type: "number",
                                  placeholder: "请输入"
                                },
                                model: {
                                  value: _vm.formItem.member.height,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formItem.member, "height", $$v)
                                  },
                                  expression: "formItem.member.height"
                                }
                              },
                              [
                                _c(
                                  "span",
                                  { attrs: { slot: "append" }, slot: "append" },
                                  [_vm._v("CM")]
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "Row",
                  [
                    _c(
                      "Col",
                      { attrs: { span: "12" } },
                      [
                        _c(
                          "FormItem",
                          { attrs: { label: "体重", prop: "member.weight" } },
                          [
                            _c(
                              "Input",
                              {
                                attrs: {
                                  type: "number",
                                  placeholder: "请输入"
                                },
                                model: {
                                  value: _vm.formItem.member.weight,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formItem.member, "weight", $$v)
                                  },
                                  expression: "formItem.member.weight"
                                }
                              },
                              [
                                _c(
                                  "span",
                                  { attrs: { slot: "append" }, slot: "append" },
                                  [_vm._v("KG")]
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "Col",
                      { attrs: { span: "12" } },
                      [
                        _c(
                          "FormItem",
                          { attrs: { label: "职业", prop: "member.job" } },
                          [
                            _c(
                              "Select",
                              {
                                staticStyle: {},
                                attrs: { placeholder: "请选择职业" },
                                model: {
                                  value: _vm.formItem.member.job,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formItem.member, "job", $$v)
                                  },
                                  expression: "formItem.member.job"
                                }
                              },
                              _vm._l(_vm.baseData.industry, function(item) {
                                return _c(
                                  "Option",
                                  { key: item.id, attrs: { value: item.id } },
                                  [_vm._v(_vm._s(item.name))]
                                )
                              }),
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "rightContent" },
              [
                _c("div", { staticClass: "title" }, [
                  _c("h3", [_vm._v("录入信息")])
                ]),
                _vm._v(" "),
                _c(
                  "Row",
                  [
                    _c(
                      "Col",
                      { attrs: { span: "8" } },
                      [
                        _c(
                          "FormItem",
                          {
                            attrs: {
                              label: "录入系统",
                              prop: "channel_info.insert_way"
                            }
                          },
                          [
                            _c(
                              "Select",
                              {
                                model: {
                                  value: _vm.formItem.channel_info.insert_way,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formItem.channel_info,
                                      "insert_way",
                                      $$v
                                    )
                                  },
                                  expression: "formItem.channel_info.insert_way"
                                }
                              },
                              _vm._l(
                                _vm.baseData.add_member_insert_way,
                                function(item) {
                                  return _c(
                                    "Option",
                                    { key: item.id, attrs: { value: item.id } },
                                    [_vm._v(_vm._s(item.name))]
                                  )
                                }
                              ),
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "Row",
                  [
                    _c(
                      "Col",
                      { attrs: { span: "8" } },
                      [
                        _c(
                          "FormItem",
                          {
                            attrs: {
                              label: "渠道",
                              prop: "channel_info.department_id"
                            }
                          },
                          [
                            _c(
                              "Select",
                              {
                                attrs: { placeholder: "请选择部门" },
                                on: { "on-change": _vm.changeChannel },
                                model: {
                                  value:
                                    _vm.formItem.channel_info.department_id,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formItem.channel_info,
                                      "department_id",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "formItem.channel_info.department_id"
                                }
                              },
                              _vm._l(_vm.departmentList, function(item) {
                                return _c(
                                  "Option",
                                  {
                                    key: item.id,
                                    attrs: { value: item.id + "" }
                                  },
                                  [_vm._v(_vm._s(item.name))]
                                )
                              }),
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "Col",
                      { attrs: { span: "6" } },
                      [
                        _c(
                          "FormItem",
                          {
                            attrs: {
                              "label-width": 0,
                              prop: "channel_info.channel_id"
                            }
                          },
                          [
                            _c(
                              "Select",
                              {
                                attrs: {
                                  filterable: "",
                                  placeholder: "请选择渠道"
                                },
                                model: {
                                  value: _vm.formItem.channel_info.channel_id,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formItem.channel_info,
                                      "channel_id",
                                      $$v
                                    )
                                  },
                                  expression: "formItem.channel_info.channel_id"
                                }
                              },
                              _vm._l(_vm.channel, function(item) {
                                return _c(
                                  "Option",
                                  {
                                    key: item.id,
                                    attrs: { value: item.id + "" }
                                  },
                                  [_vm._v(_vm._s(item.name))]
                                )
                              }),
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "Col",
                      { attrs: { span: "10" } },
                      [
                        _c(
                          "FormItem",
                          {
                            attrs: {
                              "label-width": 0,
                              prop: "channel_info.channel_explain"
                            }
                          },
                          [
                            _c("Input", {
                              attrs: { placeholder: "请输入渠道说明" },
                              model: {
                                value:
                                  _vm.formItem.channel_info.channel_explain,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.formItem.channel_info,
                                    "channel_explain",
                                    $$v
                                  )
                                },
                                expression:
                                  "formItem.channel_info.channel_explain"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "Row",
                  [
                    _c(
                      "Col",
                      { attrs: { span: "24" } },
                      [
                        _c(
                          "FormItem",
                          {
                            attrs: {
                              label: "跟进门店",
                              prop: "follow_store[0].store_id"
                            }
                          },
                          [
                            _c(
                              "Button",
                              {
                                attrs: { type: "primary" },
                                on: { click: _vm.addFollowStore }
                              },
                              [_vm._v("添加")]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _vm._l(_vm.formItem.follow_store, function(item, index) {
                  return _c(
                    "Row",
                    { key: index, staticStyle: { "margin-bottom": "10px" } },
                    [
                      _c(
                        "Col",
                        { attrs: { span: "5" } },
                        [
                          _c(
                            "FormItem",
                            {
                              attrs: {
                                "label-width": 0,
                                prop: "follow_store[" + index + "].store_id"
                              }
                            },
                            [
                              _c(
                                "Select",
                                {
                                  attrs: { placeholder: "请选择门店" },
                                  on: { "on-change": _vm.follow_store_change },
                                  model: {
                                    value: item.store_id,
                                    callback: function($$v) {
                                      _vm.$set(item, "store_id", $$v)
                                    },
                                    expression: "item.store_id"
                                  }
                                },
                                _vm._l(_vm.storeList, function(v) {
                                  return _c(
                                    "Option",
                                    { key: v.id, attrs: { value: v.id + "" } },
                                    [_vm._v(_vm._s(v.name))]
                                  )
                                }),
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "Col",
                        { attrs: { span: "5" } },
                        [
                          _c(
                            "FormItem",
                            {
                              attrs: {
                                "label-width": 0,
                                prop:
                                  "follow_store[" + index + "].member_group_id"
                              }
                            },
                            [
                              _c(
                                "Select",
                                {
                                  attrs: { placeholder: "请选择客户分组" },
                                  model: {
                                    value: item.member_group_id,
                                    callback: function($$v) {
                                      _vm.$set(item, "member_group_id", $$v)
                                    },
                                    expression: "item.member_group_id"
                                  }
                                },
                                _vm._l(_vm.customerGroudList, function(item) {
                                  return _c(
                                    "Option",
                                    {
                                      key: item.id,
                                      attrs: {
                                        "v-if": _vm.customerGroudList.length,
                                        value: item.id + ""
                                      }
                                    },
                                    [_vm._v(_vm._s(item.name))]
                                  )
                                }),
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "Col",
                        { attrs: { span: "5" } },
                        [
                          _c(
                            "FormItem",
                            {
                              attrs: {
                                "label-width": 0,
                                prop: "follow_store[" + index + "].come_status"
                              }
                            },
                            [
                              _c(
                                "Select",
                                {
                                  attrs: { placeholder: "请选择到店状态" },
                                  model: {
                                    value: item.come_status,
                                    callback: function($$v) {
                                      _vm.$set(item, "come_status", $$v)
                                    },
                                    expression: "item.come_status"
                                  }
                                },
                                _vm._l(_vm.baseData.come_status, function(
                                  item
                                ) {
                                  return _c(
                                    "Option",
                                    { key: item.id, attrs: { value: item.id } },
                                    [_vm._v(_vm._s(item.name))]
                                  )
                                }),
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      item.come_status == "2"
                        ? _c(
                            "Col",
                            { attrs: { span: "5" } },
                            [
                              _c(
                                "FormItem",
                                {
                                  attrs: {
                                    "label-width": 0,
                                    prop:
                                      "follow_store[" +
                                      index +
                                      "].return_setting_id"
                                  }
                                },
                                [
                                  _c(
                                    "Select",
                                    {
                                      attrs: { placeholder: "请选择到店方式" },
                                      model: {
                                        value: item.return_setting_id,
                                        callback: function($$v) {
                                          _vm.$set(
                                            item,
                                            "return_setting_id",
                                            $$v
                                          )
                                        },
                                        expression: "item.return_setting_id"
                                      }
                                    },
                                    _vm._l(_vm.returnSettingList, function(
                                      item
                                    ) {
                                      return _c(
                                        "Option",
                                        {
                                          key: item.id,
                                          attrs: { value: item.id + "" }
                                        },
                                        [_vm._v(_vm._s(item.return_info))]
                                      )
                                    }),
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      item.come_status == "2"
                        ? _c(
                            "Col",
                            { attrs: { span: "5" } },
                            [
                              _c("DatePicker", {
                                staticStyle: { display: "block" },
                                attrs: {
                                  format: "yyyy-MM-dd",
                                  placeholder: "请选择到店时间"
                                },
                                model: {
                                  value: item.come_date,
                                  callback: function($$v) {
                                    _vm.$set(item, "come_date", $$v)
                                  },
                                  expression: "item.come_date"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "Col",
                        { attrs: { span: 5 } },
                        [
                          item.come_status == "2"
                            ? _c(
                                "Select",
                                {
                                  attrs: { placeholder: "到店结果" },
                                  model: {
                                    value: item.arrival_result_id,
                                    callback: function($$v) {
                                      _vm.$set(item, "arrival_result_id", $$v)
                                    },
                                    expression: "item.arrival_result_id"
                                  }
                                },
                                _vm._l(_vm.arrival_result, function(item) {
                                  return _c(
                                    "Option",
                                    {
                                      key: item.id,
                                      attrs: { value: item.id + "" }
                                    },
                                    [_vm._v(_vm._s(item["result"]))]
                                  )
                                }),
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "Col",
                        { attrs: { span: 10 } },
                        [
                          item.come_status == "2" &&
                          item.arrival_result_id == "0"
                            ? _c("Input", {
                                attrs: {
                                  maxlength: 20,
                                  placeholder: "1-12个字符"
                                },
                                model: {
                                  value: item.other,
                                  callback: function($$v) {
                                    _vm.$set(item, "other", $$v)
                                  },
                                  expression: "item.other"
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      index != 0
                        ? _c(
                            "Col",
                            { attrs: { span: "4" } },
                            [
                              _c(
                                "FormItem",
                                { attrs: { "label-width": 0 } },
                                [
                                  _c(
                                    "Button",
                                    {
                                      attrs: { type: "error" },
                                      on: {
                                        click: function($event) {
                                          return _vm.delFollowStore(index)
                                        }
                                      }
                                    },
                                    [_vm._v("删除")]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                }),
                _vm._v(" "),
                _c(
                  "Row",
                  [
                    _c(
                      "Col",
                      { attrs: { span: "24" } },
                      [
                        _c(
                          "FormItem",
                          { attrs: { label: "跟进人" } },
                          [
                            _c(
                              "Button",
                              {
                                staticStyle: { "margin-right": "20px" },
                                attrs: { type: "primary" },
                                on: { click: _vm.addFollow }
                              },
                              [_vm._v("添加")]
                            ),
                            _vm._v(" "),
                            _c(
                              "Checkbox",
                              {
                                attrs: { disabled: _vm.is_follow_disabled },
                                model: {
                                  value: _vm.formItem.is_follow,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formItem, "is_follow", $$v)
                                  },
                                  expression: "formItem.is_follow"
                                }
                              },
                              [_vm._v("设我为跟进人")]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _vm._l(_vm.formItem.follow_agent, function(item, index) {
                  return _c(
                    "Row",
                    { key: index + "33" },
                    [
                      _c(
                        "Col",
                        { attrs: { span: "5" } },
                        [
                          _c(
                            "FormItem",
                            { attrs: { "label-width": 0 } },
                            [
                              _c(
                                "Select",
                                {
                                  attrs: { placeholder: "请选择门店" },
                                  on: {
                                    "on-change": function($event) {
                                      return _vm.changeStoreFollow(
                                        item.store_id,
                                        index
                                      )
                                    }
                                  },
                                  model: {
                                    value: item.store_id,
                                    callback: function($$v) {
                                      _vm.$set(item, "store_id", $$v)
                                    },
                                    expression: "item.store_id"
                                  }
                                },
                                _vm._l(_vm.get_follow_store_list, function(v) {
                                  return _c(
                                    "Option",
                                    { key: v.id, attrs: { value: v.id } },
                                    [_vm._v(_vm._s(v.name))]
                                  )
                                }),
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "Col",
                        { attrs: { span: "5" } },
                        [
                          _c(
                            "FormItem",
                            { attrs: { "label-width": 0 } },
                            [
                              _c(
                                "Select",
                                {
                                  attrs: { placeholder: "请选择部门" },
                                  on: {
                                    "on-change": function($event) {
                                      return _vm.changeDepartmentFollow(
                                        item.department_id,
                                        index
                                      )
                                    }
                                  },
                                  model: {
                                    value: item.department_id,
                                    callback: function($$v) {
                                      _vm.$set(item, "department_id", $$v)
                                    },
                                    expression: "item.department_id"
                                  }
                                },
                                _vm._l(_vm.followDepartmentList, function(
                                  item
                                ) {
                                  return _c(
                                    "Option",
                                    { key: item.id, attrs: { value: item.id } },
                                    [_vm._v(_vm._s(item.name))]
                                  )
                                }),
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "Col",
                        { attrs: { span: "5" } },
                        [
                          _c(
                            "FormItem",
                            { attrs: { "label-width": 0 } },
                            [
                              _c(
                                "Select",
                                {
                                  attrs: { placeholder: "请选择跟进人" },
                                  model: {
                                    value: item.follow_user,
                                    callback: function($$v) {
                                      _vm.$set(item, "follow_user", $$v)
                                    },
                                    expression: "item.follow_user"
                                  }
                                },
                                _vm._l(item.follow_user_data, function(item) {
                                  return _c(
                                    "Option",
                                    { key: item.id, attrs: { value: item.id } },
                                    [_vm._v(_vm._s(item.user_name))]
                                  )
                                }),
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "Col",
                        { attrs: { span: "5" } },
                        [
                          _c(
                            "FormItem",
                            { attrs: { "label-width": 0 } },
                            [
                              _c(
                                "Button",
                                {
                                  attrs: { type: "error" },
                                  on: {
                                    click: function($event) {
                                      return _vm.delFollow(index)
                                    }
                                  }
                                },
                                [_vm._v("删除")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                }),
                _vm._v(" "),
                _c("div", { staticClass: "title" }, [
                  _c("h3", [_vm._v("家属信息")])
                ]),
                _vm._v(" "),
                _c(
                  "Row",
                  [
                    _c(
                      "Col",
                      { attrs: { span: "24" } },
                      [
                        _c(
                          "FormItem",
                          { attrs: { label: "家属信息" } },
                          [
                            _c(
                              "Button",
                              {
                                attrs: { type: "primary" },
                                on: { click: _vm.addFamily }
                              },
                              [_vm._v("添加")]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _vm._l(_vm.formItem.maternal_family, function(item, index) {
                  return _c(
                    "Row",
                    { key: item.id },
                    [
                      _c(
                        "Col",
                        { attrs: { span: "5" } },
                        [
                          _c(
                            "FormItem",
                            { attrs: { "label-width": 0 } },
                            [
                              _c("Input", {
                                attrs: { placeholder: "请输入姓名" },
                                model: {
                                  value: item.name,
                                  callback: function($$v) {
                                    _vm.$set(item, "name", $$v)
                                  },
                                  expression: "item.name"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "Col",
                        { attrs: { span: "5" } },
                        [
                          _c(
                            "FormItem",
                            { attrs: { "label-width": 0 } },
                            [
                              _c(
                                "Select",
                                {
                                  attrs: { placeholder: "请选择关系" },
                                  model: {
                                    value: item.relation,
                                    callback: function($$v) {
                                      _vm.$set(item, "relation", $$v)
                                    },
                                    expression: "item.relation"
                                  }
                                },
                                _vm._l(_vm.baseData.family_relation, function(
                                  item
                                ) {
                                  return _c(
                                    "Option",
                                    {
                                      key: item.id,
                                      attrs: { value: item.name }
                                    },
                                    [_vm._v(_vm._s(item.name))]
                                  )
                                }),
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "Col",
                        { attrs: { span: "5" } },
                        [
                          _c(
                            "FormItem",
                            { attrs: { "label-width": 0 } },
                            [
                              _c("Input", {
                                attrs: {
                                  maxlength: 11,
                                  placeholder: "请输入手机号"
                                },
                                on: {
                                  "on-blur": function($event) {
                                    return _vm.familyPhoneChange(item.phone)
                                  }
                                },
                                model: {
                                  value: item.phone,
                                  callback: function($$v) {
                                    _vm.$set(item, "phone", $$v)
                                  },
                                  expression: "item.phone"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "Col",
                        { attrs: { span: "5" } },
                        [
                          _c(
                            "FormItem",
                            { attrs: { "label-width": 0 } },
                            [
                              _c(
                                "Button",
                                {
                                  attrs: { type: "error" },
                                  on: {
                                    click: function($event) {
                                      return _vm.delFamily(index)
                                    }
                                  }
                                },
                                [_vm._v("删除")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                })
              ],
              2
            )
          ]),
          _vm._v(" "),
          _c(
            "Row",
            { staticStyle: { "margin-top": "10px", "text-align": "center" } },
            [
              _c(
                "Col",
                { attrs: { span: "24" } },
                [
                  _c(
                    "Button",
                    {
                      attrs: { type: "primary", size: "large" },
                      on: {
                        click: function($event) {
                          return _vm.handleSubmit("formValidate", 1)
                        }
                      }
                    },
                    [_vm._v("提交")]
                  ),
                  _vm._v(" "),
                  _c(
                    "Button",
                    {
                      attrs: {
                        type: "primary",
                        loading: _vm.loading,
                        size: "large"
                      },
                      on: {
                        click: function($event) {
                          return _vm.handleSubmit("formValidate", 2)
                        }
                      }
                    },
                    [_vm._v("保存并创建预订单")]
                  ),
                  _vm._v(" "),
                  _c(
                    "Button",
                    {
                      attrs: { type: "default", size: "large" },
                      on: { click: _vm.cancel }
                    },
                    [_vm._v("取消")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("twoIntention", {
        attrs: {
          type: _vm.type,
          twoIntentionData: _vm.twoIntentionData,
          departmentList: _vm.departmentList,
          twoIntention: _vm.twoIntention
        },
        on: { twoIntentionEven: _vm.twoIntentionEven }
      }),
      _vm._v(" "),
      _c("addTwoIntention", {
        attrs: {
          type: _vm.type,
          addTwoIntentionData: _vm.addTwoIntentionData,
          addTwoIntentionShow: _vm.addTwoIntentionShow,
          prop_departmentList: this.departmentList,
          prop_storeList: this.storeList,
          prop_customerGroudList: this.customerGroudList,
          prop_returnSettingList: this.returnSettingList
        },
        on: { addTwoIntentionEven: _vm.addTwoIntentionEven }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-64883e5d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64883e5d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/commonTmp/CRM/CRM_addMember.vue
// module id = null
// module chunks = 